<template>
  <Card>
    <h1 slot="Title">Unexpired State</h1>
    <div slot="MainContent">
      <p>An appropriation is in the unexpired state during the fiscal year(s) for which it was made available for obligation.</p>
      <p>In this state, the appropriation can be used for both obligations and disbursements.</p>
      <p>Unexpired: 1 Oct 2019 - 30 Sep 2020</p>
    </div>
    <div slot="Notes">
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size: 16px; font-family: Calibri; color: rgb(255, 255, 255); font-weight: bold;">Unexpired State</span></p>
      <p style="line-height:normal;margin-top:4.32pt;margin-bottom:0pt;margin-left:0in;margin-right:0in;text-indent:0in;text-align:left;vertical-align:baseline;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">REF: 37-100&gt;22-FY- 3</span></span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">UNEXPIRED.&nbsp;</span><span style="font-size: 16px; font-family: Calibri;">An appropriation is in the&nbsp;</span><u><span style="font-size: 16px; font-family: Calibri;">unexpired state</span></u></span><span style="font-size: 16px; font-family: Calibri; color: rgb(255, 255, 255);">&nbsp;during the year(s) for which it was made available by Congress for obligation. &nbsp;During the unexpired state, funds can be obligated and disbursed out of the appropriation.</span></p>
    </div>
  </Card>
</template>

<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'TestPage',
  
  data() {
    return {
    }
  }
  
}
</script>